export default __webpack_public_path__ + "static/media/6t.7d5d6e64.jpg";